'use strict';

var moduleName = 'kits';

module.exports = function () {
	$('[js-kits]').each(function () {
		if($.data(this, moduleName + '-init')) return;
		$.data(this, moduleName + '-init', true);



		var wrap			   = $(this),

			product 		   = wrap.find('[js-kits-product]'),
			productReplacement = wrap.find('[js-kits-product-replacement]'),

			productPrice	   = product.find('[js-kits-product-price]'),

			btnReplace		   = wrap.find('[js-kits-product-btn-replace]'),
			btnChoose		   = wrap.find('[js-kits-product-btn-choose]'),

			recalculation  	   = wrap.find('[js-kits-product-recalculation]'),

			sum				   = wrap.find('[js-kits-sum]');



		wrap.on('change', function() {
			summarizeCosts();
		});



		btnReplace.on('click', function(e) {
			e.preventDefault();

			showReplacement($(this));
		});



		btnChoose.on('click', function(e) {
			e.preventDefault();

			replacementGoods($(this));
			changeRecalculation();
			summarizeCosts();
			checkAvailability();
		});











		function changeRecalculation() {
			recalculation.each(function() {
				var priceProduct 		    = $(this).closest(productReplacement).siblings('[js-kits-product]').find('[js-kits-product-price]').text(),
					priceProductReplacement = $(this).closest(productReplacement).find('[js-kits-product-price]').text(),
					recalculation 			= $(this).closest(productReplacement).find('[js-kits-product-recalculation]');

				var total = priceProduct - priceProductReplacement;

				if(total > 0) {
					recalculation.text('-' + total);
					recalculation.closest('.product-kits__recalculation').addClass('product-kits__recalculation_plus');
				} else {
					recalculation.text('+' + Math.abs(total));
					recalculation.closest('.product-kits__recalculation').addClass('product-kits__recalculation_minus');
				}
			});
		}

		changeRecalculation();











		function showReplacement(btn) {
			btn.closest(product).find(btnReplace).toggleClass('active');
			btn.closest(product).siblings(productReplacement).find(btnReplace).toggleClass('active');

			btn.closest(product).siblings(productReplacement).toggle();
		}






















		function replacementGoods(btn) {
			var elementProduct 			 	 = btn.closest('[js-kits-product-replacement]').siblings('[js-kits-product]'),
				elementProductRow 			 = btn.closest('[js-kits-product-replacement]').siblings('[js-kits-product]').find('.product-kits__row'),

				elementProductReplacement    = btn.closest('[js-kits-product-replacement]'),
				elementProductReplacementRow = btn.closest('[js-kits-product-replacement]').find('.product-kits__row');

			elementProductReplacementRow.after(elementProductRow);
			elementProductReplacementRow.appendTo(elementProduct);
		}



















		function summarizeCosts() {
			var costGoods = 0;

			$('[js-kits-product] [js-kits-product-checkbox]').each(function() {
				if($(this).is(':checked')) {
					costGoods += parseInt($(this).closest(product).find('[js-kits-product-price]').text());
				}
			});

			sum.text(costGoods);
		}

		summarizeCosts();





		function checkAvailability() {
			$('[js-kits-product] [js-kits-product-checkbox]').each(function() {
				if($(this).is(':disabled')) {
					$(this).closest(product).addClass('product-kits_disabled')
				} else {
					$(this).closest(product).removeClass('product-kits_disabled')
				}
			});
		}

		checkAvailability();



	});
};


/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/kitsInit.js
 **/